import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { createInvoice } from "../api/invoices";
import SuccessModal from "../components/SuccessModal";
import { useAuth } from "../context/AuthContext";
export default function NewInvoice() {
  const navigate = useNavigate();
const {
  user,
  logout
} = useAuth();
//console.log("USER:", user);
const [loggingOut, setLoggingOut] =
  useState(false);
  const [loading, setLoading] = useState(false);
const [showSuccessModal, setShowSuccessModal] =
  useState(false);
  const [form, setForm] = useState({
    clientName: "",
    email: "",
    phone: "",
    address: "",
    itemDescription: "",
    quantity: 1,
    rate: "",
    gstRate: 18,
    notes: "",
  });
  const [error, setError] = useState("");
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await createInvoice({
        client: {
          name: form.clientName,
          email: form.email,
          phone: form.phone,
          address: form.address,
        },
        items: [
          {
            description: form.itemDescription,
            quantity: Number(form.quantity),
            rate: Number(form.rate),
            gstRate: Number(form.gstRate),
          },
        ],
        notes: form.notes,
      });
setShowSuccessModal(true);
      // alert("Invoice created successfully!");
      // navigate("/invoices");
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Failed to create invoice");
    } finally {
      setLoading(false);
    }
  };
const [mobileMenu, setMobileMenu] =
  useState(false);

  const handleLogout = async () => {

  try {

    setLoggingOut(true);

    await logout();

    navigate("/");

  } catch (err) {

    console.error(err);

    setLoggingOut(false);
  }
};
  return (
    <>
      <style>{`
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');

*{
  box-sizing:border-box;
  margin:0;
  padding:0;
}

:root{
  --bg:#f5f4f0;
  --surface:#ffffff;
  --border:#e8e6e0;
  --ink:#1a1a24;
  --ink-2:#3d3d4f;
  --muted:#8a8a9a;
  --accent:#2d2b69;
  --accent-light:#eeedf8;
}

body{
  margin:0;
  background:var(--bg);
  font-family:'Sora',sans-serif;
  color:var(--ink);
  overflow-x:hidden;
}

/* =========================
   LAYOUT
========================= */

.shell{
  display:flex;
  min-height:100vh;
}

/* =========================
   SIDEBAR
========================= */

.sidebar{
  width:240px;
  background:var(--accent);
  color:white;
  position:fixed;
  top:0;
  left:0;
  height:100vh;
  padding:24px 12px;
  display:flex;
  flex-direction:column;
  z-index:1000;
  transition:transform 0.3s ease;
}

.logo{
  padding:0 55px 20px;
  border-bottom:1px solid rgba(255,255,255,0.1);
  margin-bottom:20px;
}

.logo-title{
  font-size:22px;
  font-weight:700;
}

.logo-sub{
  font-size:10px;
  opacity:0.5;
  letter-spacing:2px;
  text-transform:uppercase;
  margin-top:4px;
}

.sidebar-nav{
  flex:1;
}

.nav-item{
  display:flex;
  align-items:center;
  gap:10px;
  padding:11px 12px;
  border-radius:10px;
  margin-bottom:5px;
  color:rgba(255,255,255,0.7);
  text-decoration:none;
  font-size:13px;
  font-weight:500;
  transition:0.2s;
}

.nav-item:hover,
.nav-item.active{
  background:rgba(255,255,255,0.12);
  color:white;
}

.nav-icon{
  width:18px;
  text-align:center;
}

/* =========================
   MOBILE MENU
========================= */

.mobile-menu-btn{
  display:none;
}

.mobile-overlay{
  display:none;
}

/* =========================
   MAIN
========================= */

.main{
  flex:1;
  margin-left:240px;
  padding:40px;
  width:100%;
}

.page-header{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:20px;
  margin-bottom:32px;
  flex-wrap:wrap;
}

.page-title{
  font-size:28px;
  font-weight:700;
  letter-spacing:-1px;
}

.page-sub{
  color:var(--muted);
  margin-top:4px;
  font-size:13px;
}

.card{
  background:var(--surface);
  border:1px solid var(--border);
  border-radius:20px;
  padding:28px;
  width:100%;
  max-width:1000px;
}

/* =========================
   FORM
========================= */

.grid{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:20px;
}

.field{
  margin-bottom:18px;
}

.field.full{
  grid-column:span 2;
}

.label{
  display:block;
  margin-bottom:8px;
  font-size:12px;
  font-weight:600;
  color:var(--ink-2);
}

.input,
.textarea,
.select{
  width:100%;
  padding:14px 16px;
  border-radius:12px;
  border:1px solid var(--border);
  font-size:14px;
  font-family:'Sora',sans-serif;
  background:white;
  outline:none;
  transition:0.2s;
}

.input:focus,
.textarea:focus,
.select:focus{
  border-color:var(--accent);
  box-shadow:0 0 0 3px rgba(45,43,105,0.08);
}

.textarea{
  resize:vertical;
  min-height:120px;
}

/* =========================
   BUTTONS
========================= */

.actions{
  display:flex;
  gap:12px;
  margin-top:12px;
  flex-wrap:wrap;
}

.btn{
  border:none;
  border-radius:12px;
  padding:13px 22px;
  font-size:13px;
  font-weight:600;
  font-family:'Sora',sans-serif;
  cursor:pointer;
  transition:0.2s;
}

.btn-primary{
  background:var(--accent);
  color:white;
}

.btn-primary:hover{
  background:#3d3b8a;
  transform:translateY(-1px);
}

.btn-secondary{
  background:white;
  border:1px solid var(--border);
  color:var(--ink-2);
}

.btn-secondary:hover{
  background:var(--accent-light);
}

/* =========================
   RESPONSIVE
========================= */

@media (max-width: 900px){

  .mobile-menu-btn{
    display:flex;
    position:fixed;
    top:14px;
    left:14px;
    width:42px;
    height:42px;
    border:none;
    border-radius:10px;
    background:var(--accent);
    color:white;
    font-size:22px;
    align-items:center;
    justify-content:center;
    cursor:pointer;
    z-index:1002;
  }

  .mobile-overlay{
    display:block;
    position:fixed;
    inset:0;
    background:rgba(0,0,0,0.45);
    opacity:0;
    pointer-events:none;
    transition:0.3s;
    z-index:998;
  }

  .mobile-overlay.show{
    opacity:1;
    pointer-events:auto;
  }

  .sidebar{
    transform:translateX(-100%);
    width:240px;
    box-shadow:4px 0 20px rgba(0,0,0,0.2);
  }

  .sidebar.mobile-open{
    transform:translateX(0);
  }

  .main{
    margin-left:0;
    padding:72px 16px 24px;
  }

  .grid{
    grid-template-columns:1fr;
    gap:16px;
  }

  .field.full{
    grid-column:span 1;
  }

  .card{
    padding:18px;
    border-radius:16px;
  }

  .page-title{
    font-size:24px;
  }

  .actions{
    flex-direction:column;
  }

  .btn{
    width:100%;
  }
}

@media (max-width: 500px){

  .page-title{
    font-size:22px;
  }

  .page-sub{
    font-size:12px;
  }

  .input,
  .textarea,
  .select{
    padding:13px 14px;
    font-size:13px;
  }

  .btn{
    padding:12px 16px;
    font-size:13px;
  }
}
  /* =========================
   SIDEBAR FOOTER
========================= */

.sidebar-footer{
  padding:16px 12px;
  border-top:1px solid rgba(255,255,255,0.1);
}

.user-row{
  display:flex;
  align-items:center;
  gap:10px;
}

.user-avatar{
  width:36px;
  height:36px;
  border-radius:10px;
  background:rgba(255,255,255,0.15);
  overflow:hidden;
  display:flex;
  align-items:center;
  justify-content:center;
  color:white;
  font-weight:700;
  flex-shrink:0;
}

.user-avatar img{
  width:100%;
  height:100%;
  object-fit:cover;
}

.user-name{
  font-size:13px;
  font-weight:600;
  color:white;
}

.user-plan{
  font-size:10px;
  color:rgba(255,255,255,0.45);
  margin-top:2px;
  letter-spacing:1px;
  text-transform:uppercase;
}

.logout-btn{
  width:100%;
  margin-top:14px;
  border:none;
  background:rgba(255,255,255,0.08);
  color:rgba(255,255,255,0.7);
  padding:10px;
  border-radius:10px;
  cursor:pointer;
  transition:0.2s;
  font-size:13px;
}

.logout-btn:hover{
  background:rgba(255,80,80,0.18);
  color:#ffb4b4;
}
`}</style>
<SuccessModal
  open={showSuccessModal}
  title="Invoice Created Successfully"
  message="Your invoice has been created and saved successfully. You can now view it from your invoices list."
  buttonText="View Invoices"
  onClose={() => {
    setShowSuccessModal(false);
    navigate("/invoices");
  }}
/>

<>
  <button
    className="mobile-menu-btn"
    onClick={() =>
      setMobileMenu(!mobileMenu)
    }
  >
    ☰
  </button>

  <div
    className={`mobile-overlay ${
      mobileMenu ? "show" : ""
    }`}
    onClick={() =>
      setMobileMenu(false)
    }
  />
</>
      <div className="shell">
        <aside
  className={`sidebar ${
    mobileMenu
      ? "mobile-open"
      : ""
  }`}
>
          <div className="logo">
            <div className="logo-title">Invoice AI</div>
            <div className="logo-sub">GST · AI · India</div>
          </div>
 <nav className="sidebar-nav">
             <Link to="/dashboard" className="nav-item"><span className="nav-icon">▦</span> Dashboard</Link>
                    <Link to="/" className="nav-item"><span className="nav-icon">✨</span> WelcomePage</Link>   
                                   <Link to="/invoices" className="nav-item"><span className="nav-icon">📄</span> Invoices</Link>
                                   <Link
  to="/invoice/new"
  className="nav-item active"
>
  <span className="nav-icon">
    ＋
  </span>
  New Invoice
</Link>
                  {/* <Link to="/invoice/new" className="nav-item"><span className="nav-icon">＋</span> New Invoice</Link> */}
                  <Link to="/invoice/ai" className="nav-item"><span className="nav-icon">✦</span> AI Generate</Link>
                  <Link to="/settings" className="nav-item"><span className="nav-icon">⚙</span> Settings</Link>
                  <Link to="/billing" className="nav-item"><span className="nav-icon">💳</span> Billing</Link>
                </nav>  
                <div className="sidebar-footer">

  <div className="user-row">

    <div className="user-avatar">

      {user?.picture ? (

        <img
          src={user.picture}
          alt=""
          referrerPolicy="no-referrer"
        />

      ) : (

        (user?.name || "U")[0]
          .toUpperCase()

      )}

    </div>

    <div>

      <div className="user-name">
        {user?.name || "User"}
      </div>

                     <div className="user-plan">
  {user?.plan || "free"} plan
</div>


    </div>

  </div>

  <button
    className="logout-btn"
    onClick={handleLogout}
    disabled={loggingOut}
  >

    {loggingOut
      ? "Signing out..."
      : "Sign out"}

  </button>

</div>
        </aside>

        <main className="main">
          <div className="page-header">
            <div>
              <div className="page-title">Create Invoice</div>
              <div className="page-sub">
                Generate GST invoices with a clean professional layout
              </div>
            </div>
          </div>

          <div className="card">
            <form onSubmit={handleSubmit}>
              <div className="grid">
                <div className="field">
                  <label className="label">Client Name</label>
                  <input
                    className="input"
                    type="text"
                    name="clientName"
                    value={form.clientName}
                    onChange={handleChange}
                    placeholder="Acme Pvt Ltd"
                    required
                  />
                </div>

                <div className="field">
                  <label className="label">Email</label>
                  <input
                    className="input"
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="client@example.com"
                  />
                </div>

                <div className="field">
                  <label className="label">Phone</label>
                  <input
                    className="input"
                    type="text"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="9876543210"
                  />
                </div>

                <div className="field">
                  <label className="label">Address</label>
                  <input
                    className="input"
                    type="text"
                    name="address"
                    value={form.address}
                    onChange={handleChange}
                    placeholder="Client address"
                  />
                </div>

                <div className="field full">
                  <label className="label">Item Description</label>
                  <input
                    className="input"
                    type="text"
                    name="itemDescription"
                    value={form.itemDescription}
                    onChange={handleChange}
                    placeholder="Website Development"
                    required
                  />
                </div>

                <div className="field">
                  <label className="label">Quantity</label>
                  <input
                    className="input"
                    type="number"
                    name="quantity"
                    value={form.quantity}
                    onChange={handleChange}
                    min="1"
                  />
                </div>

                <div className="field">
                  <label className="label">Rate (₹)</label>
                  <input
                    className="input"
                    type="number"
                    name="rate"
                    value={form.rate}
                    onChange={handleChange}
                    placeholder="5000"
                    required
                  />
                </div>

                <div className="field">
                  <label className="label">GST Rate</label>
                  <select
                    className="select"
                    name="gstRate"
                    value={form.gstRate}
                    onChange={handleChange}
                  >
                    <option value={0}>0%</option>
                    <option value={5}>5%</option>
                    <option value={12}>12%</option>
                    <option value={18}>18%</option>
                    <option value={28}>28%</option>
                  </select>
                </div>

                <div className="field full">
                  <label className="label">Notes</label>
                  <textarea
                    className="textarea"
                    name="notes"
                    value={form.notes}
                    onChange={handleChange}
                    placeholder="Additional invoice notes"
                  />
                </div>
              </div>

              <div className="actions">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Creating..." : "Create Invoice"}
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/dashboard")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </>
  );
}
